import React, { Fragment } from "react"
import {
  useTable,
  useGlobalFilter,
  useSortBy,
  useFilters,
  useExpanded,
  usePagination,
} from "react-table"
import { Table, Row, Col } from "reactstrap"
import PaginationComponent from "./PaginationComponent"

const TableContainer = ({
  columns,
  data,
  page,
  size,
  count,
  params,
  setParams,
  pagination = true,
  footer = false,
}) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    footerGroups,
    rows,
    prepareRow,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: page, pageSize: size },
      pageCount: count,
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination
  )

  return (
    <Fragment>
      <div className="table-responsive react-table">
        <Table
          bordered
          {...getTableProps()}
          responsive
          style={{ whiteSpace: "nowrap" }}
        >
          <thead className="table-light table-nowrap">
            {headerGroups.map(headerGroup => (
              <tr key={headerGroup.id} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(column => (
                  <th key={column.id} {...column.getHeaderProps()}>
                    <div className="mb-2" {...column.getSortByToggleProps()}>
                      {column.render("Header")}
                    </div>
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody {...getTableBodyProps()}>
            {rows.map(row => {
              prepareRow(row)
              return (
                <Fragment key={row.getRowProps().key}>
                  <tr {...row.getRowProps()}>
                    {row.cells.map(cell => {
                      return (
                        <td key={cell.id} {...cell.getCellProps()}>
                          {cell.render("Cell")}
                        </td>
                      )
                    })}
                  </tr>
                </Fragment>
              )
            })}
          </tbody>
          {footer && (
            <tfoot>
              {footerGroups.map(footerGroup => {
                return footerGroup.headers.map(column => {
                  return column.render("Footer")
                })
              })}
            </tfoot>
          )}
        </Table>
      </div>
      {pagination !== false && (
        <Row>
          <Col
            sm="6"
            className="d-flex align-items-center justify-content-start"
          >
            <span className="d-inline-block align-items-center text-sm-start text-center my-sm-0 my-2">
              <label className="me-1">表示 :</label>
              <select
                className="form-select d-inline-block w-auto"
                value={pageSize}
                onChange={e => {
                  setParams({
                    ...params,
                    size: Number(e.target.value),
                  })
                }}
              >
                {[10, 20, 30, 40, 50].map(pageSize => (
                  <option key={pageSize} value={pageSize}>
                    {pageSize}
                  </option>
                ))}
              </select>
            </span>
          </Col>
          <Col sm="6" className="d-flex align-items-center justify-content-end">
            <PaginationComponent
              pagesCount={count}
              currentPage={pageIndex}
              setCurrentPage={setParams}
              params={params}
            />
          </Col>
        </Row>
      )}
    </Fragment>
  )
}

export default TableContainer
